// extracted by mini-css-extract-plugin
export var quantityInput = "_fy-0";